import config from '#/config';
import { scriptTag } from '#/lib/head';

/**
 * Get the pre-configured Google Tag Manager scripts
 *
 * @returns Script tags for Google Tag Manager
 */
export function googleTagManagerScripts() {
  return [
    scriptTag({
      defer: true,
      children: `
window.hsConversationsSettings = { loadImmediately: false };
window.addEventListener("load", function() {
  setTimeout(function() {
    window.HubSpotConversations.widget.load();
  }, 500);
});
      `.trim(),
    }),
    scriptTag({
      children: `
(function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':
new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],
j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src=
'https://www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);
})(window,document,'script','dataLayer','${config.gtm.key}');
            `.trim(),
    }),
  ];
}

/**
 * Add the pre-configured Google Tag Manager noscript right before the closing body tag
 *
 * @returns A noscript tag with the Google Tag Manager iframe
 */
export function GoogleNoScript() {
  return (
    <noscript
      // biome-ignore lint/security/noDangerouslySetInnerHtml: MUST do this to render the script
      dangerouslySetInnerHTML={{
        __html: `
<iframe src="https://www.googletagmanager.com/ns.html?id=${config.gtm.key}" height="0" width="0" style="display:none;visibility:hidden"></iframe>
  `.trim(),
      }}
      suppressHydrationWarning
    />
  );
}
